import { getIsStatusFundedOrEval } from '@/features/vest-capital/utils/status'; // eslint-disable-line import/no-restricted-paths
import { getDefaultLeverage } from '@/hooks/get-default-leverage'; // eslint-disable-line import/no-cycle
import { getFundedMaxLeverage } from '@/hooks/use-funded-account';
import { useAccountStore } from '@/store/use-account-store';
import { getMarketStore } from '@/store/use-markets-store';

export const getInitMarginRatio = (symbol: string, address?: string) => {
  const stored = getMarketStore(symbol).getState().leverage;
  const {
    address: storeAddress,
    getAuthParams,
    getCapitalStatus,
  } = useAccountStore.getState();
  const resolvedAddress = address ?? storeAddress;
  const accountGroup = getAuthParams(resolvedAddress)?.accountGroup;
  let leverage =
    stored ?? (accountGroup === 2 ? getDefaultLeverage(symbol) : 1);
  const fundedMax = getFundedMaxLeverage(symbol);
  if (leverage > fundedMax) {
    const capitalStatus = getCapitalStatus(resolvedAddress);
    const isFundedOrEval = getIsStatusFundedOrEval(capitalStatus);
    if (isFundedOrEval) {
      leverage = fundedMax;
    }
  }
  return 10n ** 4n / BigInt(leverage);
};
